import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-navy font-sans text-steel antialiased" data-id="element-0" data-mp="3mlja0y7k5j4n">
      <MetaPixel data-id="element-1" data-mp="3rc9f0ac2njyt" />
      <main data-id="element-2" data-mp="3rbr9so7flver">
        <Hero data-id="element-3" data-mp="3rbznujfaj6rj" />
        <LookInsideCarousel data-id="element-4" data-mp="3rdkie91luppe" />
        <Testimonials data-id="element-5" data-mp="3recd7hndojem" />
        <ProblemSection data-id="element-6" data-mp="5ygolyg4xb6" />
        <SystemSection data-id="element-7" data-mp="6801qozk67w" />
        <ModulesSection data-id="element-8" data-mp="5gfrc0u9uwx" />
        <BonusSection data-id="element-9" data-mp="82ohezguggq" />
        <UrgencySection data-id="element-10" data-mp="2zld2xbxu5jcl" />
        <PricingSection data-id="element-11" data-mp="2zm4yimrfnh2v" />
        <MoreResults data-id="element-12" data-mp="2zmo7vf30ox5a" />
        <GuaranteeSection data-id="element-13" data-mp="2zng0qi58cgrv" />
        <FAQ data-id="element-14" data-mp="33m5b01uz1i7a" />
        <ClosingSection data-id="element-15" data-mp="33lx0ggmbmoz9" />
        <SummaryTable data-id="element-16" data-mp="33n6y54p9hv5d" />
        <FinalCta data-id="element-17" data-mp="33orkw85c49so" />
      </main>
      <Footer data-id="element-18" data-mp="38l8iru2c62iy" />
      <PurchaseNotification data-id="element-19" data-mp="38li619vzxvky" />
    </div>;
}